import React from 'react';
import styled from 'styled-components';

const IconButtonWrap = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  padding: 10px 0px;
  justify-content: center;
  cursor: pointer;
`;

const IconWrap = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--orange);
  align-items: center;
  justify-content: center;
  display: flex;
  margin-right: 10px;
`;

const IconButton = ({ icon, onClick, className, children }) => (
  <IconButtonWrap className={className} onClick={onClick}>
    <IconWrap>{icon}</IconWrap>
    <span className="body-text">{children}</span>
  </IconButtonWrap>
);

export default IconButton;
